import { create } from 'zustand';

type ModalType = 'howItWorks' | 'legal' | null;

interface ModalStore {
  activeModal: ModalType;
  setActiveModal: (modal: ModalType) => void;
}

const modals = {
  howItWorks: '/how-it-works',
  legal: '/legal',
} as const;

const getModal = (path: string): ModalType =>
  (Object.entries(modals).find(([, p]) => p === path)?.[0] as ModalType) || null;

export const useModalStore = create<ModalStore>((set) => ({
  activeModal: typeof window !== 'undefined' ? getModal(window.location.pathname) : null,
  setActiveModal: (modal) => {
    set({ activeModal: modal });
    const path = modal ? modals[modal] : '/';
    if (typeof window !== 'undefined' && window.location.pathname !== path) {
      window.history.pushState({}, '', path);
    }
  },
}));

if (typeof window !== 'undefined') {
  window.addEventListener('popstate', () => {
    useModalStore.setState({ activeModal: getModal(window.location.pathname) });
  });
}
